export default __webpack_public_path__ + "static/media/mood.949cee7e.mp3";